// Generated by scripts/write-fruit-shop-replay-fixtures.ts.
// Do not edit manually.

import type { FruitShopReplayEventType } from "./event-adapter";

export interface FruitShopReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface FruitShopReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: FruitShopReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface FruitShopReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "fruit-shop";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly seed: number;
  readonly observerUserId: string;
  readonly players: readonly FruitShopReplayFixturePlayer[];
  readonly events: readonly FruitShopReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const FRUIT_SHOP_REPLAY_FIXTURES: Record<
  string,
  FruitShopReplayFixture
> = {
  "simple-13p-live": {
    schemaVersion: 1,
    gameType: "fruit-shop",
    scenario: "simple-13p-live",
    source: "generated",
    capturedAt: "2026-06-02T00:00:00.000Z",
    seed: 2026060213,
    observerUserId: "observer",
    players: [
      {
        id: "p1",
        name: "F01",
        role: "host",
      },
      {
        id: "p2",
        name: "F02",
        role: "player",
      },
      {
        id: "p3",
        name: "F03",
        role: "player",
      },
      {
        id: "p4",
        name: "F04",
        role: "player",
      },
      {
        id: "p5",
        name: "F05",
        role: "player",
      },
      {
        id: "p6",
        name: "F06",
        role: "player",
      },
      {
        id: "p7",
        name: "F07",
        role: "player",
      },
      {
        id: "p8",
        name: "F08",
        role: "player",
      },
      {
        id: "p9",
        name: "F09",
        role: "player",
      },
      {
        id: "p10",
        name: "F10",
        role: "player",
      },
      {
        id: "p11",
        name: "F11",
        role: "player",
      },
      {
        id: "p12",
        name: "F12",
        role: "player",
      },
      {
        id: "p13",
        name: "F13",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "fruit-shop-replay-simple-13p-live",
            status: "IN_PROGRESS",
            roundCount: 1,
            currentRound: {
              roundNumber: 1,
              phase: "ITEM_WINDOW",
              itemReadyPlayerIds: [],
              priceSubmissions: {},
              secretSelections: {},
              changeRecords: [],
              market: {
                APPLE: {
                  productId: "APPLE",
                  sellerCount: 4,
                },
                GRAPE: {
                  productId: "GRAPE",
                  sellerCount: 4,
                },
                KOREAN_MELON: {
                  productId: "KOREAN_MELON",
                  sellerCount: 4,
                },
                TANGERINE: {
                  productId: "TANGERINE",
                  sellerCount: 4,
                },
                STRAWBERRY: {
                  productId: "STRAWBERRY",
                  sellerCount: 5,
                },
                WATERMELON: {
                  productId: "WATERMELON",
                  sellerCount: 5,
                },
              },
              productResults: [],
              incomeByPlayerId: {},
              confirmedPlayerIds: [],
            },
            completedRounds: [],
            players: [
              {
                playerId: "p1",
                fruitRights: ["APPLE", "STRAWBERRY"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p2",
                fruitRights: ["KOREAN_MELON", "TANGERINE"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p3",
                fruitRights: ["GRAPE", "STRAWBERRY"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p4",
                fruitRights: ["GRAPE", "WATERMELON"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p5",
                fruitRights: ["STRAWBERRY", "WATERMELON"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p6",
                fruitRights: ["APPLE", "WATERMELON"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p7",
                fruitRights: ["GRAPE", "STRAWBERRY"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p8",
                fruitRights: ["GRAPE", "WATERMELON"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p9",
                fruitRights: ["KOREAN_MELON", "TANGERINE"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p10",
                fruitRights: ["KOREAN_MELON", "TANGERINE"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p11",
                fruitRights: ["APPLE", "STRAWBERRY"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p12",
                fruitRights: ["APPLE", "WATERMELON"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
              {
                playerId: "p13",
                fruitRights: ["KOREAN_MELON", "TANGERINE"],
                totalIncomeWon: 0,
                itemStatus: "AVAILABLE",
              },
            ],
            winnerIds: [],
            lowestPlayerIds: [],
            garnetAwardsByPlayerId: {},
            lifeTokenAwardsByPlayerId: {},
            extensionNumber: 0,
            hostPlayerId: "p1",
            seed: 2026060213,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SyncViewerState",
        userId: "p1",
        payload: {
          actionId: "simple-13p-live:sync-initial-view",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "UseSecret",
        userId: "p3",
        payload: {
          productId: "APPLE",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "ReadyForPriceSubmission",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 5,
        eventType: "ReadyForPriceSubmission",
        userId: "p2",
        payload: {},
      },
      {
        sequenceNumber: 6,
        eventType: "ReadyForPriceSubmission",
        userId: "p4",
        payload: {},
      },
      {
        sequenceNumber: 7,
        eventType: "ReadyForPriceSubmission",
        userId: "p5",
        payload: {},
      },
      {
        sequenceNumber: 8,
        eventType: "ReadyForPriceSubmission",
        userId: "p6",
        payload: {},
      },
      {
        sequenceNumber: 9,
        eventType: "ReadyForPriceSubmission",
        userId: "p7",
        payload: {},
      },
      {
        sequenceNumber: 10,
        eventType: "ReadyForPriceSubmission",
        userId: "p8",
        payload: {},
      },
      {
        sequenceNumber: 11,
        eventType: "ReadyForPriceSubmission",
        userId: "p9",
        payload: {},
      },
      {
        sequenceNumber: 12,
        eventType: "ReadyForPriceSubmission",
        userId: "p10",
        payload: {},
      },
      {
        sequenceNumber: 13,
        eventType: "ReadyForPriceSubmission",
        userId: "p11",
        payload: {},
      },
      {
        sequenceNumber: 14,
        eventType: "ReadyForPriceSubmission",
        userId: "p12",
        payload: {},
      },
      {
        sequenceNumber: 15,
        eventType: "ReadyForPriceSubmission",
        userId: "p13",
        payload: {},
      },
      {
        sequenceNumber: 16,
        eventType: "SubmitPrices",
        userId: "p1",
        payload: {
          prices: {
            APPLE: 1000,
            STRAWBERRY: 1000,
          },
        },
      },
      {
        sequenceNumber: 17,
        eventType: "SubmitPrices",
        userId: "p2",
        payload: {
          prices: {
            KOREAN_MELON: 5000,
            TANGERINE: 5000,
          },
        },
      },
      {
        sequenceNumber: 18,
        eventType: "SubmitPrices",
        userId: "p3",
        payload: {
          prices: {
            GRAPE: 2000,
            STRAWBERRY: 2000,
          },
        },
      },
      {
        sequenceNumber: 19,
        eventType: "SubmitPrices",
        userId: "p4",
        payload: {
          prices: {
            GRAPE: 3000,
            WATERMELON: 3000,
          },
        },
      },
      {
        sequenceNumber: 20,
        eventType: "SubmitPrices",
        userId: "p5",
        payload: {
          prices: {
            STRAWBERRY: 5000,
            WATERMELON: 5000,
          },
        },
      },
      {
        sequenceNumber: 21,
        eventType: "SubmitPrices",
        userId: "p6",
        payload: {
          prices: {
            APPLE: 1000,
            WATERMELON: 2000,
          },
        },
      },
      {
        sequenceNumber: 22,
        eventType: "SubmitPrices",
        userId: "p7",
        payload: {
          prices: {
            GRAPE: 3000,
            STRAWBERRY: 3000,
          },
        },
      },
      {
        sequenceNumber: 23,
        eventType: "SubmitPrices",
        userId: "p8",
        payload: {
          prices: {
            GRAPE: 5000,
            WATERMELON: 5000,
          },
        },
      },
      {
        sequenceNumber: 24,
        eventType: "SubmitPrices",
        userId: "p9",
        payload: {
          prices: {
            KOREAN_MELON: 2000,
            TANGERINE: 2000,
          },
        },
      },
      {
        sequenceNumber: 25,
        eventType: "SubmitPrices",
        userId: "p10",
        payload: {
          prices: {
            KOREAN_MELON: 3000,
            TANGERINE: 3000,
          },
        },
      },
      {
        sequenceNumber: 26,
        eventType: "SubmitPrices",
        userId: "p11",
        payload: {
          prices: {
            APPLE: 1000,
            STRAWBERRY: 5000,
          },
        },
      },
      {
        sequenceNumber: 27,
        eventType: "SubmitPrices",
        userId: "p12",
        payload: {
          prices: {
            APPLE: 1000,
            WATERMELON: 2000,
          },
        },
      },
      {
        sequenceNumber: 28,
        eventType: "SubmitPrices",
        userId: "p13",
        payload: {
          prices: {
            KOREAN_MELON: 3000,
            TANGERINE: 3000,
          },
        },
      },
      {
        sequenceNumber: 29,
        eventType: "ConfirmRoundResult",
        userId: "p1",
        payload: {},
      },
      {
        sequenceNumber: 30,
        eventType: "ConfirmRoundResult",
        userId: "p2",
        payload: {},
      },
      {
        sequenceNumber: 31,
        eventType: "ConfirmRoundResult",
        userId: "p3",
        payload: {},
      },
      {
        sequenceNumber: 32,
        eventType: "ConfirmRoundResult",
        userId: "p4",
        payload: {},
      },
      {
        sequenceNumber: 33,
        eventType: "ConfirmRoundResult",
        userId: "p5",
        payload: {},
      },
      {
        sequenceNumber: 34,
        eventType: "ConfirmRoundResult",
        userId: "p6",
        payload: {},
      },
      {
        sequenceNumber: 35,
        eventType: "ConfirmRoundResult",
        userId: "p7",
        payload: {},
      },
      {
        sequenceNumber: 36,
        eventType: "ConfirmRoundResult",
        userId: "p8",
        payload: {},
      },
      {
        sequenceNumber: 37,
        eventType: "ConfirmRoundResult",
        userId: "p9",
        payload: {},
      },
      {
        sequenceNumber: 38,
        eventType: "ConfirmRoundResult",
        userId: "p10",
        payload: {},
      },
      {
        sequenceNumber: 39,
        eventType: "ConfirmRoundResult",
        userId: "p11",
        payload: {},
      },
      {
        sequenceNumber: 40,
        eventType: "ConfirmRoundResult",
        userId: "p12",
        payload: {},
      },
      {
        sequenceNumber: 41,
        eventType: "ConfirmRoundResult",
        userId: "p13",
        payload: {},
      },
    ],
    notes: [
      "Fruit Shop replay fixtures model validator-produced viewer-state snapshots rather than exposing private canonical state in the UI.",
      "UseSecret hides APPLE results from observer projections until final game completion behavior allows public totals.",
      "RevealRound is validator-auto-applied after the last SubmitPrices event and is intentionally not a separate relay event in this fixture.",
    ],
  },
};
